<mat-card class="show-focus flex flex-col justify-between pl-6 pr-[1.125rem]
                 max-h-[18rem] h-[18rem] md:max-h-[15.813rem] md:h-[15.813rem] py-6 relative"
          role="region" [attr.aria-label]="productChange.title">
  <div class="flex flex-col grow mr-[0.375rem] text-[#0F0F0F] whitespace-normal">
    <a class="no-underline outline-none" tabindex="0" [attr.aria-label]="'Mehr zu ' + productChange.title"
       id="{{breakpoint}}{{productChange.id}}"
       (click)="onCardClick(productChange, $event)"
       [routerLink]="!openInNewTab ? '/product-change/details/' + productChange.id : null">
      <div class="flex flex-col-reverse sm:flex-row gap-2 sm:gap-0 grow justify-between">
        <h2 id="{{'heading_' + breakpoint + pcnr}}" class="mu-heading-5 whitespace-normal line-clamp-2">
          {{ productChange.title }}
        </h2>
      </div>
      <span class="absolute inset-0 z-[2]"></span>
    </a>
    <!-- Logik für Anzeige -->
    @if (productChange.deliveryDate) {
      @if (productChange.onlineProduct) {
        <div class="text-sm">
          {{ 'product-change-details.contained_in_month' | translate }} {{ productChange.deliveryDate | date:dateTranslationMonth }}
        </div>
      } @else {
        <div class="text-sm">
          {{ 'product-change-details.contained_in_short' | translate }} {{ productChange.deliveryDate | date:dateTranslation }}
        </div>
      }
    }
    <myupdates-change-categories class="pt-1 pb-1" id="{{'changeCat_' + breakpoint + pcnr}}"
                                 [changeCategories]="productChange.changeCategories"></myupdates-change-categories>
    <div>
      @if (productChange.teaser.length > 1) {
        <ul id="{{'teasers_' + breakpoint + pcnr}}" class="items-center flex-grow truncate"
            [ngClass]="getMultiTeaserMaxHeight('heading_' + breakpoint + pcnr)">
          @for (teaserLine of productChange.teaser; let i = $index; track i) {
            <li>
              <div class="[float:left] pl-1.5 pr-1.5" aria-hidden="true">&bull;</div>
              <div id="{{'teasers_' + breakpoint + pcnr + '_' + i}}"
                   class="product-change-card-teaser-list__item truncate whitespace-normal text-[1rem] pr-[1.781rem]"
                   [ngClass]="{'single-line': isTeaserLineCutOff('teasers_' + breakpoint + pcnr + '_' + i, 'teasers_' + breakpoint + pcnr)}">{{ teaserLine }}
              </div>
            </li>
          }
        </ul>
        <ng-container *ngTemplateOutlet="ellipsis"></ng-container>
      } @else {
        <div class="items-center flex-grow truncate whitespace-normal text-[1rem] pr-[1.781rem]"
             [ngClass]="getSingleTeaserLineClamp('heading_' + breakpoint + pcnr)">
          {{ productChange.teaser[0] }}
        </div>
      }
      <ng-template #ellipsis>
        @if (isElementVerticalOverflow('teasers_' + breakpoint + pcnr)) {
          <div>
            <span class="pl-1.5 pr-1.5" aria-hidden="true">&bull;</span>...
          </div>
        }
      </ng-template>
    </div>
  </div>
  <div aria-hidden="true" class="flex flex-row items-center self-end absolute mt-[13.5rem] md:mt-[11.313rem]">
    <div class="font-medium truncate">{{ 'product-change.caption_more' | translate }}</div>
    <mat-icon svgIcon="sli-pfeil-rechts-20"></mat-icon>
  </div>
</mat-card>
